// Matches Angular's email rule but requires a dotted domain.
const emailRegex =
    /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export const isEmailValid = (email: string): boolean => {
    if (!email?.trim()) {
        return false;
    }

    return emailRegex.test(email);
};

export const hasInvalidListEmail = (
    items: { email?: string | null }[] | null | undefined
): boolean =>
    (items ?? []).some(item => {
        const email = String(item?.email ?? '');
        return !!email.trim() && !isEmailValid(email);
    });
